(function (document) {
  'use strict';

  window.CellsPolymer.start({
    routes: {
      'customer-selection': '/',
      'pos-type-selection': '/posTypeSelection',
      'customer-info1-customer': '/customerInfo1Customer',
      'customer-info1-noncustomer': '/customerInfo1Noncustomer',
      'customer-info2': '/customerInfo2',
      'customer-info3': '/customerInfo3',
      'application-info': '/applicationInfo',
      'application-info-virtual': '/applicationInfoVirtual',
      'application-info-ceppos-first': '/applicationInfoCepposFirst',
      'application-info-ceppos-second': '/applicationInfoCepposSecond',
      'package-criteria': '/packageCriteria',
      'package-selection': '/packageSelection',
      'pos-detail-selection': '/posDetailSelection',
      'merchant-address-info': '/merchantAddressInfo',
      'merchant-address-info-virtual': '/merchantAddressInfoVirtual',
      'merchant-info': '/merchantInfo',
      'cross-question-info': '/crossQuestionInfo',
      'document-info': '/documentInfo',
      'application-end': '/applicationEnd'
    }
  });

})(document);

(function(m, c, g, connect) {
  var s = m.createElement(c);
  s.type = g;
  s.async = true;
  s.src = connect;
  m.getElementsByTagName('head')[0].appendChild(s);
  s.onload = function(){window.dataroid.init('b94d5b81-6a61-11ed-80dd-bf8114057cdb',
    'https://garantibbva.api.dataroid.com','Prod','garantibbvapos.com.tr', {
  Page: {
    checkInterval: 200, //default 500
    ignoreQueryParams: false, //default true
    ignoreReferralQueryParams: false //default true
  }
});}; }(document,'script','text/javascript',
  './scripts/dataroid-websdk.js'));
